import { ProductPageShowcase } from 'src/modules/products/components/ProductPage/ProductPageShowcase';
import { ProductDTO } from 'src/models/pim';
import { ProductPageCrossSell } from 'src/modules/products/components/ProductPage/ProductPageCrossSell';
import { ProductPageShowcaseAttribute } from 'src/modules/products/components/ProductPage/ProductPageShowcase/ProductPageShowcaseAttribute';
import { DictionaryTitlesCode } from 'src/models/pim/dictionaries';
import { ProductAttributeCode } from 'src/models/pim/attributes';
import { ProductPageLegalMentions } from 'src/modules/products/components/ProductPage/ProductPageLegalMentions';
import { ProductPageFeaturesSection } from 'src/modules/products/components/ProductPage/ProductPageFeaturesSection';
import { ProductPageSctSection } from 'src/modules/products/components/ProductPage/ProductPageSctSection';
import { ProductPageDownloads } from 'src/modules/products/components/ProductPage/ProductPageDownloads';
import { ProductPageSEO } from 'src/modules/products/components/ProductPage/ProductPageSEO';

export const ProductPageFillersTemplate = (product: ProductDTO) => {
  return (
    <>
      <ProductPageSEO {...product} />

      <ProductPageShowcase product={product}>
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.HaConcentration}
          descriptionCode={ProductAttributeCode.HaConcentration}
        />
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.Contains}
          descriptionCode={ProductAttributeCode.Ingredients}
        />
        <ProductPageShowcaseAttribute
          product={product}
          labelCode={DictionaryTitlesCode.AreaOfInjection}
          descriptionCode={ProductAttributeCode.AreaOfInjection}
        />
      </ProductPageShowcase>

      <ProductPageFeaturesSection {...product} />
      <ProductPageDownloads {...product} />
      <ProductPageSctSection {...product} />
      <ProductPageCrossSell {...product} />
      <ProductPageLegalMentions {...product} />
    </>
  );
};
